<template>
  <div id="product" class="c-content">
    <banner-child :content="banner"></banner-child>

    <product-text :content="productItem"></product-text>

    <div class="c-standard" style="padding-top: 0">
      <product-page-route :index="index"></product-page-route>
    </div>
  </div>
</template>

<script>
  import BannerChild from '../layout/bannerChild.vue'
  import ProductPageRoute from '../layout/productPageRoute.vue'
  import ProductText from '../layout/productText.vue'

  export default {
    name: 'product_4',
    components: {
      'banner-child': BannerChild,
      'product-text': ProductText,
      'product-page-route': ProductPageRoute,
    },
    data(){
      return {
        text: {
          more: this.$t('common.more')
        },
        banner: {
          img: require('../../assets/img/product/product_banner_04.jpg'),
          title: this.$t('product_4.banner.title'),
          content: this.$t('product_4.banner.content'),
        },
        index: 3,
        productItem:{
          description: this.$t('product_4.content.description'),
          items: [
            {title: this.$t('product_4.content.content.item1.title'), content: this.$t('product_4.content.content.item1.content')},
            {title: this.$t('product_4.content.content.item2.title'), content: this.$t('product_4.content.content.item2.content')},
            {title: this.$t('product_4.content.content.item3.title'), content: this.$t('product_4.content.content.item3.content')},
            {title: this.$t('product_4.content.content.item4.title'), content: this.$t('product_4.content.content.item4.content')},
            {title: this.$t('product_4.content.content.item5.title'), content: this.$t('product_4.content.content.item5.content')},
            {title: this.$t('product_4.content.content.item6.title'), content: this.$t('product_4.content.content.item6.content')},
          ],
          imgs:[
            {img: require('../../assets/img/product/product_pressalit_wash02.jpg')},
            {img: require('../../assets/img/product/product_pressalit_wash01.jpg')},
            {img: require('../../assets/img/product/product_pressalit_wash03.jpg')},
          ]
        }
      }
    },
    computed: {

    },
    created () {

    },
    methods: {

    },
  }
</script>

<style>

</style>
